import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import GroupBootstrapManager from "./components/GroupBootstrapManager";
import { GroupLicenseManager } from "./components/GroupLicenseManager";
import ManageExternalLink from "./components/ManageExternalLink";
import PresetBulkManager from "./components/PresetBulkManager";
import RuleBootstrapManager from "./components/RuleBootstrapManager";
import TemplateBulkManager from "./components/TemplateBulkManager";
import ViewBulkManager from "./components/ViewBulkManager";

export default function AdminPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ borderBottom: 1, borderColor: "divider", flexShrink: 0 }}>
        <Tab label={t("admin.tabs.licenses")} />
        <Tab label={t("admin.tabs.groups")} />
        <Tab label={t("admin.tabs.rules")} />
        <Tab label={t("admin.tabs.externalLink")} />
        <Tab label={t("admin.tabs.presets")} />
        <Tab label={t("admin.tabs.templates")} />
        <Tab label={t("admin.tabs.views")} />
      </Tabs>
      <Box sx={{ flex: 1, overflow: "auto", p: 3 }}>
        {tab === 0 && <GroupLicenseManager />}
        {tab === 1 && <GroupBootstrapManager />}
        {tab === 2 && <RuleBootstrapManager />}
        {tab === 3 && <ManageExternalLink />}
        {tab === 4 && <PresetBulkManager />}
        {tab === 5 && <TemplateBulkManager />}
        {tab === 6 && <ViewBulkManager />}
      </Box>
    </Box>
  );
}
